import { FC } from "react";
import { BehavioralAssessment } from "./BehavioralAssessment";
import { AppQueryPopupsController } from "../../AppQueryPopupsBloc";
import { BehavioralAssessmentDialogStructure } from "./BehavioralAssessmentDialogStructure";
import { Button } from "@9amhealth/shared";
import Translate from "src/ui/components/Translate/Translate";
import envVariables from "src/lib/envVariables";
import { useBlocNext } from "@blac/react";
import { useBloc } from "src/state/state";
import { LyraConsentCubit } from "src/state/Lyra/LyraConsentCubit";
import { FeatureFlags } from "src/lib/featureFlags";
import { PopupDialogTrigger } from "molecule/popupDialog/PopupDialogTrigger";
import { BehavioralPopupConnectLyra } from "./BehavioralPopupConnectLyra";

interface BehavioralAssessmentActionSwitchProps {
  assessment: BehavioralAssessment;
  structure: BehavioralAssessmentDialogStructure;
}

const AllRight: FC<
  BehavioralAssessmentActionSwitchProps & { isLoading: boolean }
> = ({ isLoading, structure }) => (
  <Button
    theme="sunrise"
    size="large"
    isDisabled={isLoading}
    onPress={() => {
      AppQueryPopupsController.closePopup();
    }}
  >
    <Translate msg={structure.action} />
  </Button>
);

const ApiDisabled: FC<BehavioralAssessmentActionSwitchProps> = ({
  structure
}) => (
  <Button
    theme="sunrise"
    size="large"
    onPress={() => {
      window.open(envVariables.LYRA_CONNECT_URL, "_blank");
      AppQueryPopupsController.closePopup();
    }}
  >
    <Translate msg={structure.action} />
  </Button>
);

const ApiEnabled: FC<
  BehavioralAssessmentActionSwitchProps & { isLoading: boolean }
> = ({ isLoading, structure }) => (
  <PopupDialogTrigger>
    <Button theme="sunrise" size="large" isDisabled={isLoading}>
      <Translate msg={structure.action} />
    </Button>
    <BehavioralPopupConnectLyra />
  </PopupDialogTrigger>
);

export const BehavioralAssessmentActionSwitch: FC<
  BehavioralAssessmentActionSwitchProps
> = (props) => {
  const [{ isLoading }] = useBlocNext(LyraConsentCubit);
  const [, { isLyraIntegrationEnabled }] = useBloc(FeatureFlags);

  switch (props.assessment) {
    case "allRight":
      return <AllRight {...props} isLoading={isLoading} />;
    case "maybe":
      return isLyraIntegrationEnabled ? (
        <ApiEnabled {...props} isLoading={isLoading} />
      ) : (
        <ApiDisabled {...props} />
      );
    case "recommend":
      return isLyraIntegrationEnabled ? (
        <ApiEnabled {...props} isLoading={isLoading} />
      ) : (
        <ApiDisabled {...props} />
      );
  }
};
